import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-52406e36"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "panel" }
const _hoisted_2 = { class: "section" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-header" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "河川断面")
], -1))
const _hoisted_4 = { class: "section-body" }

import { computed } from 'vue'
import WaterDiagram from '@/components/common/WaterDiagram.vue'
import { useWaterDetailStore } from '@/stores/waterDetailStore'
import { useGlobalStore } from '@/stores/globalStore'
import { Threshold } from '@/models/InitData'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const globalStore = useGlobalStore()
const waterDetailStore = useWaterDetailStore()

const ap = computed(() => {
  const station = globalStore.currentStation

  return station?.ap
})

const scale = computed(() => {
  const result = globalStore.currentStation?.scale || { min: 0, max: 7, span: 7 }

  return result
})

const current = computed(() => {
  return waterDetailStore.current
})
const currentTime = computed(() => {
  return waterDetailStore.currentTime
})
const thresholds = computed(() => {
  return globalStore.waterThreshold.reduce((memo, t) => {
    memo[t.status] = t

    return memo
  }, {} as { [key: string]: Threshold })
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(WaterDiagram, {
          value: _unref(current),
          time: _unref(currentTime),
          thresholds: _unref(thresholds),
          scale: _unref(scale),
          showTooltip: true,
          ap: _unref(ap),
          type: "water-detail"
        }, null, 8, ["value", "time", "thresholds", "scale", "ap"])
      ])
    ])
  ]))
}
}

})